import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { ConnectionTemplateConnectionGroupFormPresentation } from './connection-template-connection-group-form.presentation';
import { ConnectionTemplateConnectionGroupFormVM } from './connection-template-connection-group-form.viewmodel';
import { ConnectionTemplatesFormVM } from '../../connection-template-form.viewmodel';
import { IConnectionTemplateConnectionGroupDTO } from '../../../../../../api/blueprints/connection.template.types';

type ConnectionTemplateConnectionGroupFormProps = {
    group?: IConnectionTemplateConnectionGroupDTO;
    templateformVM: ConnectionTemplatesFormVM;
    closeGroupIdToEditPopup?: (meetingConnectionId: string) => void;
};

export const ConnectionTemplateConnectionGroupForm = withViewModel(
    ConnectionTemplateConnectionGroupFormPresentation,
    (props: ConnectionTemplateConnectionGroupFormProps) => {
        const {
            group,
            templateformVM,
            closeGroupIdToEditPopup,
        } = props;
        const vm = new ConnectionTemplateConnectionGroupFormVM(
            templateformVM,
            group,
            closeGroupIdToEditPopup
        );
        return vm;
    },
    () => [], vm => {
        vm.onUnmount();
    }
);
